export default "__VITE_ASSET__pgXzSXNi__"